import axiosPrivateInstance from './AxiosPrivateInstance';

export const getAllTable = async () => {
    try {
        const res = await axiosPrivateInstance.get('/restaurant-table-list/');
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};
export const addNewTable = async data => {
    try {
        const res = await axiosPrivateInstance.post(
            `restaurant-table-list/`,
            data
        );
        return res.data;
    } catch (error) {
        console.log(error);
    }
};

export const getTableDetailsById = async id => {
    try {
        const res = await axiosPrivateInstance.get(
            `/restaurant-table-detail/?pk=${id}`
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};
export const updateTableDetails = async (id, data) => {
    try {
        const res = await axiosPrivateInstance.patch(
            `restaurant-table-detail/?pk=${id}`,
            data
        );
        return res.data;
    } catch (error) {
        console.log(error);
    }
};
export const getAllCategoryList = async () => {
    try {
        const res = await axiosPrivateInstance.get(
            'restaurant-table-category-list/'
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};
export const addNewCategory = async data => {
    try {
        const res = await axiosPrivateInstance.post(
            `restaurant-table-category-list/`,
            data
        );
        return res.data;
    } catch (error) {
        console.log(error);
    }
};

export const getCategoryDetailsById = async id => {
    try {
        const res = await axiosPrivateInstance.get(
            `/restaurant-tablecategory-detail/?id=${id}`
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};
export const updateCategoryDetails = async (id, data) => {
    try {
        const res = await axiosPrivateInstance.patch(
            `restaurant-tablecategory-detail/?id=${id}`,
            data
        );
        return res.data;
    } catch (error) {
        console.log(error);
    }
};
export const getAllOccasionList = async () => {
    try {
        const res = await axiosPrivateInstance.get(
            'restaurant-occassion-list/'
        );
        console.log(res.data, 'occasion');
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};
export const getAllCuisineList = async () => {
    try {
        const res = await axiosPrivateInstance.get('restaurant-cuisine/');
        console.log(res.data, 'occasion');
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};
export const updateReserSettings = async data => {
    try {
        const res = await axiosPrivateInstance.patch(
            'restaurant-reservation-config/',
            data
        );
        return res.data; // Return the full response object with status and data
    } catch (error) {
        console.log(error);
        return { status: 'error', message: error.message };
    }
};

export const getReservationDetails = async () => {
    try {
        const res = await axiosPrivateInstance.get(
            'restaurant-reservation-config/'
        );
        return res.data;
    } catch (error) {
        console.log(error);
    }
};
export const getDeliverySettings = async data => {
    try {
        const res = await axiosPrivateInstance.get(
            'restaurant-delivery-config/',
            data
        );

        console.log(res, 'delivery');
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const updateDeliverySettings = async data => {
    try {
        const res = await axiosPrivateInstance.patch(
            'restaurant-delivery-config/',
            data
        );
        return res.data; // Return the full response object with status and data
    } catch (error) {
        console.log(error);
        return { status: 'error', message: error.message };
    }
};

export const getTakeawaySettings = async () => {
    try {
        const res = await axiosPrivateInstance.get(
            'restaurant-takeaway-config/'
        );
        return res.data.data[0];
    } catch (error) {
        console.log(error);
    }
};
export const updateTakeawaySettings = async data => {
    try {
        const res = await axiosPrivateInstance.patch(
            'restaurant-takeaway-config/',
            data
        );
        return res.data;
    } catch (error) {
        console.log(error);
    }
};

export const getCateringSettings = async () => {
    try {
        const res = await axiosPrivateInstance.get(
            'restaurant-catering-config/'
        );
        console.log(res.data, 'resdetails');
        return res.data.data[0];
    } catch (error) {
        console.log(error);
    }
};
export const updateCateringSettings = async data => {
    try {
        const res = await axiosPrivateInstance.patch(
            'restaurant-catering-config/',
            data
        );
        return res.data;
    } catch (error) {
        console.log(error);
    }
};

export const getRestaurantSettings = async () => {
    try {
        const res = await axiosPrivateInstance.get(
            'restaurant-settings-config/'
        );
        console.log(res.data, 'resdetails');
        return res.data.data[0];
    } catch (error) {
        console.log(error);
    }
};
export const updateRestaurantSettings = async data => {
    try {
        const res = await axiosPrivateInstance.patch(
            'restaurant-settings-config/',
            data
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};
export const updateSlotSettings = async (id, data) => {
    console.log(id, data);
    try {
        const res = await axiosPrivateInstance.patch(
            `edit-reservation-slote/?sloteid=${id}`,
            data
        );
        return res.data.data;
    } catch (error) {
        console.error('Error in updateSlotSettings:', error);
        throw error; // Re-throw the error so it can be caught by the calling function
    }
};
